export default {
    "created": "Deal-ul a fost creat cu succes",
    "updated": "Deal-ul a fost actualizat cu succes",
    "deleted": "Deal-ul a fost șters cu succes",
    "restored": "Deal-ul a fost restaurat cu succes",
}
